import { MapMarker } from '../models/mapModel';

export const isChecked = ({ selected, option }: { selected: any; option: MapMarker }) => {
    if (!selected || !selected.dropPoint) return false;

    if (option._type === 'store') {
        return selected.dropPoint._id === option._id;
    }

    return selected.dropPoint.storeId === option._id;
};
